import { createSlice } from '@reduxjs/toolkit';
import { companyApi } from 'features/company/query';
import { type TCompanyState } from 'features/company/types';

const initialState: TCompanyState = {
  companyList: null,
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {},
  extraReducers: builder => {
    const { GetCompanyList } = companyApi.endpoints;

    builder.addMatcher(GetCompanyList.matchFulfilled, (state, { payload }) => {
      state.companyList = payload ?? null;
    });
  },
});

export default companySlice.reducer;
